module.exports = __webpack_public_path__ + "static/img/16.0f34971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/16.png
// module id = IpXb
// module chunks = 1